function os() {
    //this.disable || (this.checked = !this.checked,
    //this.calculative.canvas.store.emitter.emit("valueUpdate", this),
    //this.calculative.canvas.render(1 / 0))
    this.value = !this.value;
}
export function switchobj(ctx, node) {
    node.onDestroy || (node.click = os);
    let i = node.rect.x
      , n = node.rect.y;
    node.rect.width;
    let r = node.rect.height;
    return ctx.beginPath(),
    ctx.arc(i + r / 2, n + r / 2, r / 2, Math.PI / 2, 3 * Math.PI / 2),
    ctx.lineTo(i + 3 * r / 2, n),
    ctx.arc(i + 3 * r / 2, n + r / 2, r / 2, -Math.PI / 2, Math.PI / 2),
    ctx.lineTo(i + r / 2, n + r),
    //node.checked=node.value,
    node.value ? (ctx.fillStyle = node.onColor,
    node.disable && (ctx.fillStyle = node.disableOnColor),
    ctx.fill(),
    ctx.closePath(),
    ctx.beginPath(),
    ctx.fillStyle = "#ffffff",
    ctx.moveTo(i + 2 * r, n + r / 2),
    ctx.arc(i + 3 * r / 2, n + r / 2, r / 2 > 2 ? r / 2 - 2 : 1, 0, 2 * Math.PI),
    ctx.fill()) : (ctx.fillStyle = node.offColor,
    node.disable && (ctx.fillStyle = node.disableOffColor),
    ctx.fill(),
    ctx.closePath(),
    ctx.beginPath(),
    ctx.fillStyle = "#ffffff",
    ctx.moveTo(i + r, n + r / 2),
    ctx.arc(i + r / 2, n + r / 2, r / 2 > 2 ? r / 2 - 2 : 1, 0, 2 * Math.PI),
    ctx.fill()),
    ctx.closePath(),
    !1
}


/*export function register_switch() {
  (window).Le5leTopology.registerNode('switchobj', switchobj);
}*/